<template>
  <v-row justify="center">
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-progress-linear v-if="bCargando" indeterminate color="titlesdark darken-2" />
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span v-if="sDetalleTitulo!=''" class="mdlHeadForms">{{sDetalleTitulo}}</span> 
          <span v-else-if="modNuevo" class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.lblNuevo}} {{tituloForm}}</span> 
          <span v-else class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.lblEditar}} {{tituloForm}}</span>
          <v-spacer />
          <v-btn color="btncolor-dark" dark @click="CloseDialog()" icon small outlined>
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="pa-2" v-if="!bCargando">
          <v-row no-gutters>
            <v-col v-if="sDetalleTitulo!=''">
              <v-card>
                <v-container v-if="sDetalleTitulo!=''" fluid class="border-card mb-2 cont-expander-infocard" :class="bVerTodo ? 'h-completo':'h-minimo'">
                  <div :class="[bVerTodo ? 'h-completo-desvanecido':'h-minimo-desvanecido', 'caja-desvanecido']">
                    <v-btn class="btn-vermas-infocard" @click="aMostrarCompleto" color="primary" dark dense small rounded>
                      <v-icon left>{{bVerTodo ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                      {{bVerTodo ? 'Ver Menos':'Ver Más'}}
                    </v-btn>
                  </div>
                  <!--h3 class="text-medium ml-1 mb-2">
                    {{ sDetalleTitulo }}
                  </h3-->
                  <v-row v-for="(campo, index) in oDetalle.items" :key="index" class="no-gutters">
                    <v-col sm="4" md="4" lg="4" cols="12"  class="py-0 ma-0" v-if="onConsultarHeader(index)!=''">
                      <span class="text-medium text-primary ml-1">
                        {{ onConsultarHeader(index)}}
                      </span>
                    </v-col>
                    <v-col sm="8" md="8" lg="8" cols="12"  class="py-0 ma-0"  v-if="onConsultarHeader(index)!=''">
                      <p class="info-text-cardexpander">
                        {{campo}}
                      </p>
                    </v-col>
                  </v-row>            
                </v-container>
              </v-card>
            </v-col>
            <v-row class="no-gutters" >
              <v-col sm="12" cols="12" :md="campo.cols" 
              :lg="campo.cols" :xl="campo.cols" 
              v-for="(campo, index) in campos"
              :key="index +campo.nombre +nKeyCleanCampos"  class="pa-1 ma-0">
                <component 
                  :ref="`form-${campo.nombre}`"
                  :is="campo.tipo" 
                  v-model="oFormCampos[campo.nombre]"
                  v-if="campo.Visible === '1' ? true : false"
                  :titulo="campo.label"
                  :obligatorio="campo.obligatorio == 1 ? true : false"
                  :condicion="campo.Condicion"
                  :inner="campo.innerJoin"
                  :campo="campo.nombre"
                  :campoFiltro="campo.CampoFiltro"
                  :valorFiltro="campo.ValorFiltro"
                  :sCampoModificaA="campo.ModificaA"
                  :editable="campo.editable"
                  :nCiudad="oFormCampos.NombreCiudad"
                  :oDataCoordenadas="{lat:oFormCampos.lat , lng: oFormCampos.lng}"
                  :sTabla="tableName"
                  :aParametros="aParametros"
                  :sInfoAyuda="campo.info"
                  @ErrorCampo="onAlmacenarErrorCampo"
                  @ModificaA="onModificarCampo"
                  @onArchivosSubiendo="(bSubiendo) => btnEnable=bSubiendo">
                </component>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-1" v-if="campos.length>0">
          <v-row justify="center" class="no-gutters my-2 pa-1">
            <v-col sm="12" cols="12">
              <small class="d-flex justify-end mt-2"> <span class="error--text mr-1">*</span> <span class="titleslight--text font-weight-medium">{{$store.state.jsIdioma.oEquivalencias.lblCampo}} {{$store.state.jsIdioma.oEquivalencias.lblObligatorio}}</span></small>
            </v-col>
            <v-col cols="12" class="text-center" >
              <v-divider class="mb-3" />
              <v-btn rounded outlined class="mx-1"  color="btncolor" @click="onLimpiarCampos" :disabled="btnEnable">{{ $store.state.jsIdioma.oEquivalencias.btnLimpiar }}</v-btn>
              <v-btn class="mx-1" v-if="modNuevo" color="primary" @click="onSalvar" rounded :disabled="btnEnable">{{ $store.state.jsIdioma.oEquivalencias.btnGuardar }}</v-btn>
              <v-btn class="mx-1" v-else color="primary" @click="onActualizar" rounded :disabled="btnEnable">{{ $store.state.jsIdioma.oEquivalencias.btnActualizar }}</v-btn>
            </v-col>
         </v-row> 
        </v-card-actions>
      </v-card>
      <error-view v-model="bMostrarErrores" :aErrores="aErroresMensaje"></error-view>
      
    </v-dialog>
    <ModalMensajeGeneral v-model="oModalMensaje.bModalVisible" :sMensaje="oModalMensaje.sMensaje" :nTipo="oModalMensaje.nTipo"/>
  </v-row>
</template>

<script>

import {mapGetters} from 'vuex'
import mxFunciones from '@/mixins/funciones.js'

import axiosServices from '@/services/axiosServices.js'
import numero from '@/components/Form/Componentes/FormNumero.vue'
import formlabel from '@/components/Form/Componentes/FormLabel.vue'
import texto from '@/components/Form/Componentes/FormTexto.vue'
import datetext from '@/components/Form/Componentes/FormDate.vue'
import dateRango from '@/components/Form/Componentes/FormDateRango.vue'
import selector from '@/components/Form/Componentes/FormSelect.vue'
import selectordependiente from '@/components/Form/Componentes/FormSelectFiltro.vue'
import selectorMultiple from '@/components/Form/Componentes/FormMultiSelect.vue'
import correo from '@/components/Form/Componentes/FormCorreo.vue'
import campoSiNo from '@/components/Form/Componentes/FormSiNo.vue'
import campoSwitch from '@/components/Form/Componentes/FormSwitch.vue'
import archivo from '@/components/Form/Componentes/FormFile.vue'
import direccion from '@/components/Form/Componentes/FormDireccion.vue'
import latitud from '@/components/Form/Componentes/FormLatitud.vue'
import longitud from '@/components/Form/Componentes/FormLongitud.vue'
import activoInactivo from '@/components/Form/Componentes/FormActivoInactivo.vue'
import selectordoble from '@/components/Form/Componentes/FormDoubleSelect.vue'
import selectordobledependiente from '@/components/Form/Componentes/FormDoubleSelectDep.vue'
import pickcolor from '@/components/Form/Componentes/FormColor.vue'
import textArea from '@/components/Form/Componentes/FormTextArea.vue'
import FormArchivos from '@/components/Form/Componentes/FormArchivos.vue'
import iconos from '@/components/Form/Componentes/FormIcono.vue'
import jsFormulario from "@/Utlidades/FormularioUtils.js"
import ErrorView from '@/components/ErrorView.vue'
import editorhtml from '@/components/Form/Componentes/FormHtmlEditor.vue'
import FormBanner from './Componentes/FormBanner.vue'
import FormQuillEditor from './Componentes/FormQuillEditor.vue'
import FormToggle from './Componentes/FormToggle.vue'


export default {
  name:'Form',
  mixins: [mxFunciones], 
  components: {
    numero,
    texto,
    datetext,
    dateRango,
    selector,
    selectordependiente,
    correo,
    selectorMultiple,
    campoSiNo,
    campoSwitch,
    archivo,
    direccion,
    latitud,
    longitud,
    activoInactivo,
    selectordoble,
    selectordobledependiente,
    pickcolor,
    textArea,
    ErrorView,
    formlabel,
    FormArchivos,
    iconos,
    editorhtml,
    FormBanner,
    FormQuillEditor,
    FormToggle
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      defaul: ''
    },
    oItem: {
      // objeto con los valores del Item a modificar en caso de edit
      type:Object,
      defaul:{}
    },
    modNuevo:{
      type:Boolean,
      default:true
    },
    titulo: {   
      type: String,
      default: ''
    },
    oDetalle: {
      // objeto con los valores del Item a modificar en caso de edit
      type:Object,
      defaul:{}
    },
    sDetalleTitulo: {
      type: String,
      default: ''
    },
    idItem: {
      type: String,
      default: ''
    },
    sCampoFiltro: {
      type: String,
      default: ''
    },
    nIdValor: {
      type: Number,
      default: 0
    },
    oDataFormularioAdicional: {
      type: Object,
       default: () => {}
    },
    bSubdominioTemporal: {
      type: Boolean,
      default: false
    },
    aParametros: {
      type: Array,
      default: () => []         // Listado de string que contiene parametros adicionales que se usan para realizar filtrado, este listado son campos existentes.
    },
    bDataFormularioAdicionalObligatorio: { // Permite que la data adicional que viene en la prop oDataFormularioAdicional sea tratada como obligatorio al momento de crear nuevo registro con el formulario
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      bCargando       : true,                            // empleada para indicar que el form esta bCargando
      campos          : [],                               // arreglo de campos del formulario  
      oFormCampos     : {},
      btnEnable       : false,
      aErroresMensaje : [],                               // Arreglo de mensajes para la plataforma,
      bMostrarErrores : false,                            // variableque muestra los errores
      tituloForm      : '' ,
      oErrosEmitComponentes : {},                         // Objeto en donde almacenos los errores emitidos por cada componente.
      nKeyCleanCampos : 0,                                // Indice que se incrementa para indicar que se limpiaron los campos y que debe refrescar.
      bVerTodo        : false,
      oModalMensaje: {
        bModalVisible: false,
        sMensaje: '',
        nTipo: 2
      },
    }//fin return
  },// Fin Data
  async mounted(){
    await this.loadDataEdit()
    await this.getCampos()
    if(this.titulo == ""){
      this.tituloForm = await this.getTitulo(this.tableName)
    } else {
      this.tituloForm = this.titulo
    }
  },
  methods: {
    async loadDataEdit(){
      if(!this.modNuevo){
        this.modNuevo = false
        this.bCargando = true
        let sParam = ''
        if(this.idItem.indexOf(",") !== -1) {
          // Como vienen dos o mas de dos primero split (convierto en array) el texto 
          const aIDItem = this.idItem.split(',')
          // recorro el array y creo un string para pasarlos a 
          let oItemResp = {}
          aIDItem.forEach(idItem =>  oItemResp[idItem] = this.oItem[idItem])

          sParam = `sTable=${this.tableName}` + '&Item=' + JSON.stringify(oItemResp)

        } else  {
          sParam = `sTable=${this.tableName}` + '&Item=' + this.oItem[this.idItem]
        }
        await axiosServices.getConfiguration('/formulario_item', true, sParam ).then(aItemData =>{
          this.oFormCampos = aItemData.aData[0]
          // Si el formulario trae los campos lat o lng los guardamos en el store para que puedan ser cargados hacia el campo tipo direccion si se implementa.
          if((Object.prototype.hasOwnProperty.call(this.oFormCampos, 'lat')) && (Object.prototype.hasOwnProperty.call(this.oFormCampos, 'lng'))){
            this.$store.dispatch('savelatlng',{lat:this.oFormCampos.lat,lng:this.oFormCampos.lng})
          }
          this.onValidarModificadores()
          this.bCargando = false
        })
      }else{
        this.bCargando = true
        if(Object.keys(this.oItem).length > 0){
          this.oFormCampos = this.oItem
        }
        this.bCargando = false
      }
    },
    onValidarModificadores() {
      this.campos.forEach(oItem => {
        if (oItem.ModificaA !== '') {
          if(Object.prototype.hasOwnProperty.call(this.oFormCampos, oItem.nombre)) this.onModificarCampo(oItem.ModificaA, this.oFormCampos[oItem.nombre])
        }
      })
    },
    async getCampos(){
      this.bCargando = true
      let sParams = 'sTable='+ this.tableName
      const aCampos = await axiosServices.getConfiguration('/formulario_campos',true, sParams)
      this.campos = aCampos.aData
      this.campos.filter(e => e.tipo === 'direccion').forEach(() => {
        if(this.oFormCampos.lat === ''){
          this.oFormCampos.lat = ''
          this.oFormCampos.lng = ''
        }
      });
      this.bCargando = false
      /**Validar codigo */
      let valorFiltro = this.nIdValor; // Valor seteado desde la prop nIdValor de Grid
      if(this.sCampoFiltro != ""){     // Valor seteado desde la prop sCampoFiltro de Grid
        this.campos.forEach((e,index) => {
          if(this.sCampoFiltro == e["label"]) this.campos.splice(index, 1);
          if(this.sCampoFiltro == e["nombre"] && e["tipo"]=="selector") valorFiltro = `${this.nIdValor}`; // Para los campos tipo Select, su valor siempre es String
        })
        this.oFormCampos[this.sCampoFiltro] = valorFiltro
      } 
      this.onCargarDatos()
      if(!this.modNuevo) this.onValidarModificadores()
    },
    onCargarDatos() {
      this.campos.forEach((e,index) => {
        if(this.campos[index].editable == "2"){
          this.campos[index].editable = '0'
        }
        else if(this.modNuevo) this.campos[index].editable = '1'
        // Se queman datos para los campos texto 
        if(this.campos[index].Visible === '0' && this.campos[index].Condicion !== '' && this.campos[index].Condicion !== null && this.campos[index].tipo === 'texto'){
          const rex = /&&\w+&&/gi;
          if(this.campos[index].Condicion) {
            if(this.campos[index].Condicion.match(rex).length > 0){
              this.oFormCampos[this.campos[index].nombre] = this.onBuscarPropiedad(this.$store.state, this.campos[index].Condicion.replaceAll('&&', '')) !== undefined ? this.onBuscarPropiedad(this.$store.state, this.campos[index].Condicion.replaceAll('&&', '')) : this.campos[index].Condicion
            }else{
              this.oFormCampos[this.campos[index].nombre] = this.campos[index].Condicion
            }
          } else {
            this.oFormCampos[this.campos[index].nombre] = this.campos[index].Condicion
          }
        }
      })
    },
    onBuscarPropiedad(obj, propiedad) {
      if(obj != null && obj != undefined){
        // Si el objeto tiene la propiedad buscada, se retorna su valor
        if (obj.hasOwnProperty(propiedad)) {
          return obj[propiedad];
        }

        // Recorrer cada propiedad del objeto
        for (var p in obj) {
          // Si la propiedad es un objeto, llamar recursivamente la función
          if (typeof obj[p] === "object") {
            var resultado = this.onBuscarPropiedad(obj[p], propiedad);
            // Si se encuentra la propiedad en el objeto interno, retornar su valor
            if (resultado !== undefined) {
              return resultado;
            }
          }
        }
      }
      // Si no se encontró la propiedad, retornar undefined
      return undefined;
    },
    CloseDialog() {
      this.oFormCampos = {}
      this.$emit('input', false)
      this.$emit('onCerrar')
      // Al cerrar el formulario seteamos en vacio los campos de coordenadas para un nuevo uso
      this.$store.dispatch('savelatlng',{lat:'',lng:''})
    },
    async onSalvar(){
      this.btnEnable = true  
      //Si data adicional ES obligatorio agregamos los campos con los valores antes de la validacion de los campos
      if(this.bDataFormularioAdicionalObligatorio){
        Object.keys(this.oDataFormularioAdicional).forEach(sKey =>{
            this.oFormCampos[sKey] =this.oDataFormularioAdicional[sKey]
          })
      }
      const oValidacion = jsFormulario.onValidarCamposForm(this.campos, this.oFormCampos)
      if(oValidacion.bError){
        this.btnEnable = false
        this.bCargando = false
        this.aErroresMensaje = oValidacion.aMensajes
        this.bMostrarErrores = true
        return 
      }
      else{
        
        let sParams = 'sTable='+ this.tableName
        
        this.bCargando = true
        //this.onCargarDatos()

        let aAnexosSubir = [];
        //validar si se debe subir algun archivo
        Object.keys(this.oFormCampos).forEach(sKey =>{
          // Para las formularios que guardan mas de un anexo se formatea la lista con los objetos de los archivos.
          // Debe existir una tabla de anexos relacionada a la tabla del form, la relacion se configura en el archivo /src/config/parametros.ini del API
          if(sKey=='anexos'){
            this.oFormCampos[sKey]=this.onFormatearAnexos(this.oFormCampos[sKey]);
          }else{
            // Para cualquier otro campo de tipo anexo se asume que es un solo archivo, el cual se agregara en un campo anexo de la tabla del form
            const nIndex = this.campos.findIndex(oItem => oItem.nombre === sKey)
            if(this.campos[nIndex].tipo === 'FormArchivos') {
              this.oFormCampos[sKey]=this.oFormCampos[sKey][0].name;
            }
          }
          if(sKey=='lat'){
            //obtenemos las coordenadas y validamos que tenga la data
            if(this.getlatlng?.lat){
              this.oFormCampos[sKey]=this.getlatlng?.lat;
            }
          }
          else if(sKey=='lng'){
            //obtenemos las coordenadas y validamos que tenga la data
            if(this.getlatlng?.lng){
              this.oFormCampos[sKey]=this.getlatlng?.lng;
            }
          }
        })
        if(aAnexosSubir.length>0){
          // this.oFormCampos['anexos']=aAnexosSubir[0].name;
          // Se comenta esta seccion ya que el mismo componente se encarga de subir los archivos
          await this.onSubirAnexos(aAnexosSubir);
        }
        //Si data adicional NO ES obligatorio agregamos los campos con los valores despues de la validacion de los campos
        if(!this.bDataFormularioAdicionalObligatorio){
          Object.keys(this.oDataFormularioAdicional).forEach(sKey =>{
            this.oFormCampos[sKey] =this.oDataFormularioAdicional[sKey]
          })
        }
        const oResponse =  await axiosServices.postConfiguration('/formulario', this.oFormCampos, true, sParams)
        if (oResponse.sStatus == 'success'){
          this.bCargando = true
          this.$swal({
            timer: 1500,
            icon:`${oResponse.sStatus}`,
            title:`${oResponse.sMessage}`,
            showConfirmButton: false
          })
          this.oFormCampos.id = oResponse.aData
          this.$emit('saveOK', this.oFormCampos)
          this.oFormCampos = {}
          this.CloseDialog()
        }
        else{
          this.btnEnable = false
          this.bCargando = false
        }

        
      }
    },
    validarCampos(){
      this.aErroresMensaje = []
      // esta funcion valida que los campos obligatorios esten completos y regrese un objeto de los errores true indica que hay error
      // tomo el objeto de elementos y los recorro uno a uno
      let oFormError      = {}
      let aux_nombreCampo = ''
      let bRspVAlidar     = true   // variable empleada para dar la respueta de si se continua con el post o no

      // primero valido que no tenga errores informados por los campos.
      const aCampos = Object.keys(this.oErrosEmitComponentes)
      if(aCampos.length > 0 ) {
        // hay errores
        aCampos.forEach( e => {
          oFormError[e] = true
          this.aErroresMensaje.push(`${this.$store.state.jsIdioma.oEquivalencias.lblErrorEn} ${e}: ${this.oErrosEmitComponentes[e]} `)
        })
        
        this.$store.dispatch('saveoFormError',oFormError)
        return false
      } 


      for (let prop in this.campos ){
        aux_nombreCampo = this.campos[prop].nombre
        // valido si es obligatorio y si tienen valor
        if(this.oFormCampos[aux_nombreCampo] != undefined){
          if(this.campos[prop].obligatorio == '1' && this.oFormCampos[aux_nombreCampo] != '' && !this.oFormCampos[aux_nombreCampo].includes("'")){
            oFormError[aux_nombreCampo] = false
          }else{
            if(this.campos[prop].obligatorio == '0'){
              oFormError[aux_nombreCampo] = false
            }else{
              //validamos si es problema de comillas
              if(this.oFormCampos[aux_nombreCampo].includes("'")){
                this.aErroresMensaje.push(`${this.$store.state.jsIdioma.oEquivalencias.lblCampo} ${this.campos[prop].label} ${this.$store.state.jsIdioma.oEquivalencias.lblErrorComilla}.`)
              }
              else{
                this.aErroresMensaje.push(`${this.$store.state.jsIdioma.oEquivalencias.lblCampo} ${this.campos[prop].label} ${this.$store.state.jsIdioma.oEquivalencias.lblObligatorio}.`)  // Campo XXX Obligatorio
              }
              oFormError[aux_nombreCampo] = true
              bRspVAlidar = false
            }  
          }  
        }else{
           if(this.campos[prop].obligatorio == '0'){
              oFormError[aux_nombreCampo] = false
            }else{
              this.aErroresMensaje.push(`${this.$store.state.jsIdioma.oEquivalencias.lblCampo} ${this.campos[prop].label} ${this.$store.state.jsIdioma.oEquivalencias.lblObligatorio}.`)
              oFormError[aux_nombreCampo] = true
              bRspVAlidar = false
            }  
        }
      }
      this.$store.dispatch('saveoFormError',oFormError)
      return bRspVAlidar

    },
    onModificarCampo(sCampoModificado, sValor) {
      const nIndex = this.campos.findIndex(oItem => oItem.nombre === sCampoModificado)
      this.campos[nIndex].ValorFiltro = sValor

      if(this.campos[nIndex].tipo === 'selectordependiente') {
        this.campos[nIndex].ValorFiltro = sValor
      }else {
        this.oFormCampos[this.campos[nIndex].nombre] = sValor
      }
    },
    onLimpiarCampos(){
      this.campos.forEach(element => {
        if(element.editable == '1' && element.nombre){
          this.oFormCampos[element.nombre] = null
        }
      });
      this.nKeyCleanCampos++
    },
    async onEliminarPropiedadesNulas(objeto) {
      for (let clave in objeto) {
        if (objeto.hasOwnProperty(clave) && (objeto[clave] === null || objeto[clave] === undefined)) {
          delete objeto[clave];
        }
      }
    },
    async onActualizar(){
      this.btnEnable = true  

      const oValidacion = jsFormulario.onValidarCamposForm(this.campos, this.oFormCampos)
      if(oValidacion.bError){
        this.btnEnable = false
        this.bCargando = false
        this.aErroresMensaje = oValidacion.aMensajes
        this.bMostrarErrores = true
        return 
      }
      else{
        let sParams = 'sTable='+ this.tableName
        let oPut = {nuevo:{}, viejo:{}}
        Object.keys(this.oFormCampos).forEach(sKey => {
          if(this.oFormCampos[sKey] ){
            if(sKey=='lat'){
              //obtenemos las coordenadas y validamos que tenga la data
              if(this.getlatlng?.lat){
                this.oFormCampos[sKey]=this.getlatlng?.lat;
              }
            }
            else if(sKey=='lng'){
              //obtenemos las coordenadas y validamos que tenga la data
              if(this.getlatlng?.lng){
                this.oFormCampos[sKey]=this.getlatlng?.lng;
              }
            }
            oPut.nuevo[sKey] = this.oFormCampos[sKey]
          }
        })
        oPut.viejo = this.oItem
        if(this.idItem.indexOf(",") !== -1) {
          // Como vienen dos o mas de dos primero split (convierto en array) el texto 
          const aIDItem = this.idItem.split(',')
          // recorro el array y creo un string para pasarlos a 
          let oItemResp = {}
          aIDItem.forEach(sItem =>  oItemResp[sItem] = this.oItem[sItem])

          oPut.nuevo.id = oItemResp

        } else  {
          oPut.nuevo.id = this.oItem[this.idItem]
        }

        this.bCargando = true
        let aAnexosSubir = [];
        //validar si se debe subir algun archivo
        Object.keys(this.oFormCampos).forEach(sKey =>{
          if(sKey=='UrlLogo'){
            if(this.oFormCampos[sKey] !== null && this.oFormCampos[sKey] !== undefined  && this.oFormCampos[sKey] !== ''){
              aAnexosSubir = [...this.oFormCampos[sKey]]
              this.oFormCampos[sKey]=this.oFormCampos[sKey][0][0].name;
            }
          }
          if(sKey=='lat'){
            //obtenemos las coordenadas y validamos que tenga la data
            if(this.getlatlng?.lat){
              this.oFormCampos[sKey]=this.getlatlng?.lat;
            }
          }
          else if(sKey=='lng'){
            //obtenemos las coordenadas y validamos que tenga la data
            if(this.getlatlng?.lng){
              this.oFormCampos[sKey]=this.getlatlng?.lng;
            }
          }
        })
        if(aAnexosSubir.length>0){
          //this.oFormCampos['anexos']=aAnexosSubir[0].name;
          await this.onSubirAnexos(aAnexosSubir);
        }
        let oResponse =  await axiosServices.putConfiguration('/formulario', oPut, true, sParams)
        if (oResponse.sStatus == 'success'){
          this.bCargando = false
          this.btnEnable = false
          this.$swal({
            timer: 1500,
            icon:`${oResponse.sStatus}`,
            title:`${oResponse.sMessage}`,
            showConfirmButton: false
          })
          this.oFormCampos = {}
          this.$emit('saveOK')
          this.CloseDialog()
        }
      }    

    },
    onConsultarHeader(index){
      let sValor = ''
      this.oDetalle.headers.forEach(item=>{
        if (item.value==index && item.visible!=undefined && item.visible=="1") sValor = item.text
      })

      return sValor
    },
    onAlmacenarErrorCampo(oErrorEmitido) {
      
      if(oErrorEmitido.sMsgError === null) {
        delete this.oErrosEmitComponentes[oErrorEmitido.campo]
      } else {
        this.oErrosEmitComponentes[oErrorEmitido.campo] = oErrorEmitido.sMsgError
      }

    },
    aMostrarCompleto(){
      this.bVerTodo =! this.bVerTodo
    }

  },
  computed: {
    ...mapGetters(['getlatlng'])
  },
}
</script>

<style lang="scss"  scoped>
  .caja-desvanecido{
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: end;
    align-items:flex-end;
    .btn-vermas-infocard{
      margin: 0px 5px 5px 0px;
    }
  }
  .h-minimo-desvanecido{
    background: rgb(255,255,255);
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 12%, rgba(255,255,255,0.87718837535014) 33%, rgba(255,255,255,0) 100%);
  }
  .h-completo-desvanecido{
    background: none;
  }
  .h-completo{
    height: auto;
    overflow: auto;
    padding: 10px 10px 50px 10px!important;
    .caja-desvanecido{
      height: 40px;
      border-top: solid #e3e3e3 1px;
    }
  }
  .h-minimo{
    height: 200px;
    overflow: hidden;
    padding: 10px 10px 10px 10px!important;
    .caja-desvanecido{
      height: 80px;
      border-top: none;
    }
  }
  .info-text-cardexpander{
    font-size: 0.95em;
    line-height: 1.1em;
    margin: 0px;
    padding: 0px;
  }
  .info-text-cardexpander{
    font-size: 0.95em;
    line-height: 1.1em;
    margin: 0px;
    padding: 0px;
  }
</style>